module.exports = __webpack_public_path__ + "assets/img/透明去购买.b2302959.png";